import styled from 'styled-components';

type SizeProps = {
  $width?: number | string;
  $height?: number | string;
};

const toCSS = (value: number | string) => (typeof value === 'number' ? `${value}px` : value);

export const Container = styled.div<SizeProps>`
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  ${({ $width }) => $width !== undefined && `width: ${toCSS($width)};`}
  ${({ $height }) => $height !== undefined && `height: ${toCSS($height)};`}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ActivityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;

  & + & {
    border-top: 1px solid #f5f5f5;
  }
`;

export const RowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const TextLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RowRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`;
